export default "__VITE_ASSET__BLFMhEB6__"